/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sso_No_Organizations_AddressInputs */



/**
* | output |
* | --- |
* | "Send your administrator this address so they can add you:" |
*
* @param {Auth_Sso_No_Organizations_AddressInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_sso_no_organizations_address = /** @type {((inputs?: Auth_Sso_No_Organizations_AddressInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sso_No_Organizations_AddressInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sende deinem Administrator diese Adresse, damit er dich hinzufügen kann:")
	return /** @type {LocalizedString} */ ("Send your administrator this address so they can add you:")
});